/**
 * ACRES User — Lucky Draw view (your entries, prizes, past winners)
 */
import React, { useEffect, useState } from 'react';
import { acres } from '../../../lib/services/acresService';

export const AcresLuckyDrawUser: React.FC<{ user?: any }> = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    acres.getSummary().then(s => setData(s)).catch(e => setError(e?.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ color: '#9CA3AF' }}>Loading…</div>;
  if (error) return <div style={errBox}>{error}</div>;

  const draw = data?.current_draw || {};
  const myEntries = Number(data?.draw_entries_this_month || 0);
  const platforms: Record<string, number> = data?.entries_by_platform || {};
  const prizes: any[] = draw?.prizes || [];
  const pastWinners: any[] = data?.past_winners || [];

  return (
    <div>
      <div style={{ ...card, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>🎰 Monthly Lucky Draw — {(draw.month_year || '').slice(0,7) || 'this month'}</div>
            <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 4 }}>Earn entries by completing tasks. 21 tasks on a single platform = bonus entry. Status: <b>{draw.status || 'open'}</b></div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 11, color: '#9CA3AF' }}>Your entries this month</div>
            <div style={{ fontSize: 32, fontWeight: 700, color: '#F59E0B' }}>{myEntries}</div>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 12 }}>
        <div style={card}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>Entries by Platform</div>
          {Object.keys(platforms).length ? (
            Object.entries(platforms).map(([p, n]) => (
              <div key={p} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #1E1E1E', fontSize: 13 }}>
                <span>{p}</span><span style={{ fontWeight: 600 }}>{n}</span>
              </div>
            ))
          ) : <div style={{ color: '#9CA3AF', fontSize: 12 }}>No entries yet — complete tasks to earn entries.</div>}
        </div>

        <div style={card}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>This Month's Prize Pool</div>
          {prizes.length ? prizes.map((pr, i) => (
            <div key={i} style={{ padding: '6px 0', borderBottom: '1px solid #1E1E1E', fontSize: 13 }}>
              <div style={{ fontWeight: 600 }}>#{pr.rank} · {pr.title}</div>
              <div style={{ fontSize: 11, color: '#9CA3AF' }}>{pr.prize_type}{pr.prize_value ? ` · ${pr.prize_value}` : ''} · qty {pr.quantity}</div>
            </div>
          )) : <div style={{ color: '#9CA3AF', fontSize: 12 }}>Prize pool will be announced soon.</div>}
        </div>

        <div style={card}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>Past Winners</div>
          {pastWinners.length ? pastWinners.slice(0, 8).map((w, i) => (
            <div key={i} style={{ padding: '6px 0', borderBottom: '1px solid #1E1E1E', fontSize: 12 }}>
              <div>{w.month_year?.slice(0,7)} · #{w.rank}</div>
              <div style={{ color: '#9CA3AF' }}>{w.user_handle || `user#${w.user_id}`} · {w.prize_title}</div>
            </div>
          )) : <div style={{ color: '#9CA3AF', fontSize: 12 }}>No past draws yet.</div>}
        </div>
      </div>
    </div>
  );
};

const card: React.CSSProperties = { background: '#0F0F0F', border: '1px solid #1E1E1E', borderRadius: 8, padding: 14 };
const errBox: React.CSSProperties = { padding: 10, background: 'rgba(220,38,38,0.1)', border: '1px solid #DC2626', borderRadius: 6, color: '#FCA5A5' };
